// ============== importing Token Image ===================
import tokenVideo from "assets/videos/token.mp4";

// ========================= Token Section ====================
const Token = () => {
  return (
    <section id="token">
      <div className="container">
        <div className="sec-heading-wrapper">
          {/* ================ Main heading ======================= */}
          <h1 className="sec-heading colored" data-aos="fade-up">
            $STREAM Token
          </h1>
        </div>
        <div className="row token_row">
          <div className="token_left">
            {/* ================== Body text ========================== */}
            <p data-aos="fade-up">
              We believe in empowering creators & giving them full control over
              their creative output. They should be able to benefit from the
              engagement of their fans in a fair & sustainable way, no matter
              how big or small their audience is, rather than relying on ads &
              impression algorithms. We also believe that slow pay-out times &
              poor revenue splits are a thing of the past, & income should not
              be dictated by intermediary entities who can demonetize your
              videos at any time. With the $STREAM token people can now support
              their favourite creators by sending tokens directly to their
              wallet thus removing any middlemen & essentially decentralizing
              the whole process. WeStream will still be completely FREE to use,
              & creators will still be able to earn revenue via ads should they
              choose to do so, but with our platform, they can now earn extra
              rewards by monetizing the interactions with their fans such as
              likes, chats, calls & DMs.
            </p>
          </div>
          <div className="token_right">
            {/* ================= Token Image ==================== */}
            <video
              src={tokenVideo}
              muted="true"
              loop="true"
              autoplay="true"
            ></video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Token;
